import { render, staticRenderFns } from "./thumbnail.vue?vue&type=template&id=764094d1&scoped=true&"
import script from "./thumbnail.vue?vue&type=script&lang=js&"
export * from "./thumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764094d1",
  null
  
)

export default component.exports